import { useEffect, useState } from "react";
import { SimpleModalControls } from "../Modal";
import Modal from "../Modal";
import { useTranslation } from "react-i18next";
import { Divider, Input } from "@chakra-ui/react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import InventoryModal from "../../pages/Inventory/components/InventoryModal";

interface ModalSearchInAllInvnetoriesInterface extends SimpleModalControls {

}

const ModalSearchInAllInvnetories = (props: ModalSearchInAllInvnetoriesInterface) => {
    const {
        isOpen,
        onClose
    } = props;

    const { t } = useTranslation("translations");

    const [searchTerm, setSearchTerm] = useState<string>("");
    const [sku, setSku] = useState<string>("");

    const [items, setItems] = useState<any>({});
    const [selectedItem, setSelectedItem] = useState<any | null>(null);

    const fetch = async () => {
        try {
            const res = await getAxiosInstance().get(`/Inventory/Search/${searchTerm}`);

            const formatedItems: any = formatApiData(res.data);

            setItems(formatedItems);

        } catch (e) {
            toast.warn(t("CAN_T_FIND_PRODUCT_WITH_NAME") as string, { position: "bottom-right" });
        }
    }

    const bySku = async () => {
        try {
            const res = await getAxiosInstance().get(`/Inventory/SKU/Search/${sku}`);

            const formatedItems: any = formatApiData(res.data);

            setItems(formatedItems);
        } catch (e) {
            toast.warn(t("CAN_T_FIND_PRODUCT_WITH_NAME") as string, { position: "bottom-right" });
        }
    }

    const formatApiData = (data: any[]) => {
        const formatedItems: any = {};

        /**
         * Create an object map for each company and add compute the quantity for products with the same id
         */
        for (const business of data) {
            const keys = Object.keys(formatedItems);

            // If the company is not in the map add it
            if (keys.findIndex(x => x === business.companyName) === -1) {
                formatedItems[business.companyName] = { name: business.companyName, items: [] }
            }

            const items: any[] = [];

            for (const item of business.items) {
                const index = items.findIndex(x => x.productId === item.productId);

                if (index !== -1) {
                    items[index].quantity += item.quantity;
                } else {
                    items.push({ ...item });
                }
            }

            formatedItems[business.companyName].items.push({
                ...business,
                items: items
            })
        }

        return formatedItems;
    }

    useEffect(() => {
        if (searchTerm.length > 3) {
            fetch();
        }
    }, [searchTerm]);


    useEffect(() => {
        if (sku.length > 3) {
            bySku();
        }
    }, [sku]);

    return (
        <Modal
            header={t("GLOBAL_INVENTORY_SEARCH")}
            isOpen={isOpen}
            onClose={onClose}
            size={"full"}
        >
            <>
                <div>
                    <Input
                        name='name'
                        disabled={sku.length > 0}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder={t("SEARCH_PRODUCT_AFTER_NAME")}
                    />
                    <Divider className="mb-4 mt-2" />
                    <Input
                        name='sku'
                        disabled={searchTerm.length > 0}
                        value={sku}
                        onChange={(e) => setSku(e.target.value)}
                        placeholder={t("SEARCH_PRODUCT_AFTER_SKU")}
                    />
                </div>
                <div>
                    {Object.keys(items).map((business: string) => (
                        <div className="p-2">
                            <div className="mb-2 ml-1 text-xl">{business}</div>
                            <div className="border p-4 ">
                                {
                                    items[business].items.map((x: any) => (<div className="p-2">
                                        <div>
                                            {x.placeOfBusinessName} {`(${x.companyName})`}
                                        </div>
                                        <Divider className="mb-4 mt-2" />
                                        {
                                            x.items.map((y: any) => <div onClick={() => setSelectedItem({
                                                ...x,
                                                productId: y.productId
                                            })} className="m-2 py-2 px-4 rounded-xl flex justify-between hover:bg-slate-300">
                                                <div>{y.productName}</div>
                                                <div>{y.quantity} {`(${y.um})`}</div>
                                            </div>)
                                        }
                                    </div>))
                                }
                            </div>
                        </div>
                    ))
                    }
                </div>

                <InventoryModal
                    open={selectedItem}
                    onClose={() => setSelectedItem(null)}
                    id={selectedItem?.productId}
                    placeOfBusinessId={selectedItem?.placeOfBusinessId}
                    name={`(${selectedItem?.placeOfBusinessName} - ${selectedItem?.companyName})`}
                />
            </>
        </Modal>
    )
}

export default ModalSearchInAllInvnetories;